"use client";

import React from "react";

const WhatIsFluoride: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        What is Fluoride?
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Fluoride is a naturally occurring mineral found in soil, water, and even in small amounts in our food. It&#39;s been widely recognized for its benefits to oral health since the 1940s when it was first added to public water supplies in the United States. This practice has significantly reduced tooth decay among children and adults alike.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Fluoride works by making our teeth more resistant to acids produced by harmful bacteria that feed on sugar in our mouths. These bacteria can cause tooth enamel to lose minerals, leading to weakened teeth and eventually cavities. Fluoride helps to reverse this process through a phenomenon called remineralization, where it attracts other minerals to the enamel layer of our teeth, making them stronger.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        But how does fluoride get into our teeth? Well, it doesn&#39;t just sit on the surface – it actually becomes part of the tooth&#39;s structure. When we consume foods and drinks containing fluoride, or use fluoride toothpaste, the mineral is absorbed into the enamel layer of our teeth, providing ongoing protection against decay.
      </p>
    </div>
  );
};

export default WhatIsFluoride;